<template>
  <div class="home-MyApp">
    <div v-for="(item, index) in data" :key="index" class="item" @click="selectClick(item)">
      <img :src="item.logoUrl" />
      <div class="item-right">
        <h3>{{item.name}}</h3>
        <label v-if="item.countList.length === 0">暂无待办</label>
        <template v-else>
          <a-tag v-for="(td,i) in item.countList" :key="i" color="#F0F0F0">{{td.name}} {{td.count}}</a-tag>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { startMicroApp } from '@/utils/microTools'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  props: {
    data: Array
  },
  data() {
    return { }
  },
  computed: {
    ...mapGetters(['systemList'])
  },
  methods: {
    openBlankTab({ internetSubSystemUrl }) {
      const token = this.$cookie.get(ACCESS_TOKEN)
      if (internetSubSystemUrl && token) {
        window.open(`${internetSubSystemUrl}&tokenId=${token}`, '_blank')
      }
    },
    selectClick(item) {
      const { systemList } = this
      if (Array.isArray(systemList)) {
        const obj = systemList.find(ele => ele.code === item.code)
        if (obj) {
          // 外部系统跳转到iframe
          if (item.internetSubSystem) {
            this.openBlankTab(item)
          } else {
            startMicroApp(obj)
          }
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.home-MyApp{
  .item{
    min-width: 300px;
    background: #FAFAFA;
    border: 1px solid transparent;
    display: inline-flex;
    padding: 24px;
    border-radius: 5px;
    align-items: center;
    margin-right: 16px;
    margin-bottom: 16px;
    img{
      width: 50px;
      height: 50px;
    }
    .item-right{
      margin-left: 20px;
      h3{
        font-size: 16px;
        color: #202121;
        font-weight: 500;
        margin-bottom: 5px;
      }
      label{
        font-size: 12px;
        color: #949898;
      }
      .ant-tag{
        color: #949898;
        border:none;
        font-size: 12px;
        padding:2px 8px;
      }
    }
    &:hover{
      background: #F3FBFA;
      border-color: #00A497;
    }
  }
}
</style>
